import * as React from 'react';
export const firstniagaraSvg = React.forwardRef(function firstniagaraSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#fafcfc',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M10.727 32H0V17.822C3.695 20.062 6.97 23.984 10.727 32zm6.468 0h-5.412C8.883 25.234 5.6 19.175 0 15.864v-8.63c9.034 8.21 14.567 17.041 17.195 24.767zm4.055 0h-2.046C15.925 22.845 10.828 11.898.001 1.545L0 0h2.238c5.005 4.983 14.39 17.314 19.012 32z',
        fill: '#1ea6e6',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.507 32h-2.033C20.02 23.302 15.774 11.455 6.9 0h3.874C16.07 7.734 21.12 15.35 24.507 32zM32 0v32h-5.1c-1.316-8.481-3.595-18.238-11.845-32z',
        fill: '#ffcb3b',
      }),
    ),
  );
});
firstniagaraSvg.defaultProps = {
  height: '32',
  viewBox: '0 0 32 32',
  width: '32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var firstniagara = {
  category: 'brand',
  colorable: false,
  name: 'firstniagara',
  svg: firstniagaraSvg,
};
